import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";
import { Meeting } from "../types/meetings";
import { convertToMeeting } from "../services/supabase/utils";

export function useMeetings(userId: string | undefined) {
  return useQuery({
    queryKey: ['meetings', userId],
    queryFn: async () => {
      if (!userId) {
        throw new Error('User ID is required');
      }

      console.log('Fetching meetings for user:', userId);

      const { data: meetings, error } = await supabase
        .from('meetings')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching meetings:', error);
        throw error;
      }

      // Convert the meetings data to the correct type using the utility function
      return meetings.map(meeting => convertToMeeting(meeting)) as Meeting[];
    },
    enabled: !!userId,
    retry: false,
  });
}